module.exports = __webpack_public_path__ + "static/aerial-views-xii-74fbda50594d3fc811e75af7d3da7725.jpg";